require("./src/styles/global.css");
exports.shouldUpdateScroll = () => false;